import SettingsManager, { SdkSettings } from './lib/SettingsManager';
import ApiFetch from './lib/ApiFetch';
import Categories from './namespaces/Categories';
import Themes from './namespaces/Themes';
import Providers from './namespaces/Providers';
import Games from './namespaces/Games';
import Bonuses from './namespaces/Bonuses';
import BonusHistory from './namespaces/BonusHistory';
import BonusGames from './namespaces/BonusGames';
import Jackpot from './namespaces/Jackpot';
import HallOfFame from './namespaces/HallOfFame';
import CrudConsumerInterface from './namespaces';

export { AbortController } from './lib/http';
export { FRONT_API_GATEWAY_ERROR_CODES } from './constants/FrontApiGatewayErrors';
export { API_RESPONSE } from 'eva-fe-sdk-types';
export { default as NetworkError } from './lib/NetworkError';

interface SDK {
  categories: CrudConsumerInterface;
  themes: CrudConsumerInterface;
  providers: CrudConsumerInterface;
  games: CrudConsumerInterface;
  bonuses: CrudConsumerInterface;
  bonusHistory: CrudConsumerInterface;
  bonusGames: CrudConsumerInterface;
  jackpot: CrudConsumerInterface;
  hallOfFame: CrudConsumerInterface;
  //
  fetch: ApiFetch['fetch'];
  settings: object;
}

function lobbySdk(sdkSettings: SdkSettings): SDK {
  const settings = new SettingsManager(sdkSettings);
  const apiFetch = new ApiFetch(settings);
  const productType: string = settings.getProductType();

  return {
    categories: new Categories(apiFetch, productType),
    themes: new Themes(apiFetch, productType),
    providers: new Providers(apiFetch, productType),
    games: new Games(apiFetch, productType),
    bonuses: new Bonuses(apiFetch, productType),
    bonusHistory: new BonusHistory(apiFetch, productType),
    bonusGames: new BonusGames(apiFetch, productType),
    jackpot: new Jackpot(apiFetch, productType),
    hallOfFame: new HallOfFame(apiFetch, productType),
    //
    fetch: apiFetch.fetch.bind(apiFetch),
    settings,
  };
}

export default lobbySdk;
